import { render, staticRenderFns } from "./bookingHistory.vue?vue&type=template&id=775c141a"
import script from "./bookingHistory.vue?vue&type=script&lang=js"
export * from "./bookingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports